'use client'

import type { ImageLoaderProps } from 'next/image'

export default function myImageLoader({ src, width: _width, quality: _quality }: ImageLoaderProps) {
  // return `https://${process.env.NEXT_PUBLIC_SERVER_URL}/${src}?w=${width}&q=${quality || 75}`
  return src
}
